var checkIsArrayEmpty = function (arr) {
    return (arr || []).length === 0;
};

export { checkIsArrayEmpty };
//# sourceMappingURL=array.js.map
